<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import BoxType from './BoxType'
import FleetCategory from './FleetCategory'
import FleetType from './FleetType'
import TermoType from './TermoType'
import FuelType from './FuelType'
import OperationalNotes from './OperationalNotes'

import {
  BOX_MUTATION_CREATE,
  BOX_MUTATION_UPDATE,
  GET_BOX,
} from '@/services/api/setting/fleet/boxType'

import {
  CATEGORY_MUTATION_CREATE,
  CATEGORY_MUTATION_UPDATE,
  GET_CATEGORY,
} from '@/services/api/setting/fleet/fleetCat'
import {
  GET_VEHICLE_TYPE,
  VEHICLE_TYPE_MUTATION_CREATE,
  VEHICLE_TYPE_MUTATION_UPDATE,
} from '@/services/api/setting/fleet/fleetType'
import {
  GET_THERMO,
  THERMO_MUTATION_CREATE,
  THERMO_MUTATION_UPDATE,
} from '@/services/api/setting/fleet/thermoType'
import {
  GET_OPERATIONAL_NOTES,
  OPERATIONAL_NOTES_MUTATION_CREATE,
  OPERATIONAL_NOTES_MUTATION_UPDATE,
} from '@/services/api/setting/fleet/operationalNotes'
import { mapGetters } from 'vuex'

/**
 * Starter component
 */
export default {
  page: {
    title: 'Setting',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    FleetCategory,
    FleetType,
    BoxType,
    TermoType,
    FuelType,
    OperationalNotes,
  },
  apollo: {
    vehicleCategories: {
      query: GET_CATEGORY,
      manual: true,
      result() {},
    },

    boxTypes: {
      query: GET_BOX,
    },

    thermoTypes: {
      query: GET_THERMO,
    },

    vehicleTypes: {
      query: GET_VEHICLE_TYPE,
    },

    operationalNotes: {
      query: GET_OPERATIONAL_NOTES,
    },
  },
  computed: {
    title() {
      return this.$t('setting.list.fleetSetting.settingFleet')
    },
    subTitle() {
      return this.$t('setting.list.fleetSetting.textFleet')
    },
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    breadcrumbItems() {
      return [
        {
          text: this.$t('setting.homePage.pengaturan'),
          to: '/setting',
        },
        {
          text: this.$t('setting.list.fleetSetting.settingFleet'),
        },
      ]
    },
  },
  mounted() {
    this.$store.commit('setting/SET_STATUS', 'FleetCategory')
  },
  methods: {
    toSave() {
      switch (this.$store.state.setting.status) {
        case 'FleetCategory':
          this.saveCategory()
          break
        case 'BoxType':
          this.saveBox()
          break

        case 'TermoType':
          this.saveTermo()
          break

        case 'FleetType':
          this.saveType()
          break

        case 'OperationalNotes':
          this.saveOperationalNotes()
          break

        default:
          // eslint-disable-next-line no-console
          console.log('Tidak Terdefinisi')
      }
    },
    saveCategory() {
      let validate = this.$refs.fleetCat.validateForm()
      if (validate) {
        return
      }
      let promises = []
      for (const iterator of this.$store.state.setting.data.fleetCategory) {
        if (!iterator) continue
        let input = {}
        let mutation = null

        if (!iterator.newId) {
          input = {
            oldCategory: iterator.oldCategory,
            newCategory: iterator.category,
          }
          mutation = CATEGORY_MUTATION_UPDATE
        } else {
          input = {
            category: iterator.category,
          }

          mutation = CATEGORY_MUTATION_CREATE
        }
        promises.push(
          this.$apollo.mutate({
            mutation: mutation,
            variables: {
              input: input,
            },
          })
        )
      }

      Promise.all(promises)
        .then(() => {
          this.$mcToast.success(this.$t('global.alert.text.saved'))
          this.$store.commit('setting/SET_DATA', { fleetCategory: [] })
          this.$apollo.queries.vehicleCategories.refetch()
          this.$refs.fleetCat.changeSortStatus()
          this.$refs.fleetCat.resetForm()
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
    },

    saveBox() {
      let validate = this.$refs.fleetBox.validateForm()
      if (validate) {
        return
      }

      let promises = []
      for (const iterator of this.$store.state.setting.data.boxType) {
        if (!iterator) continue
        let input = {}
        let mutation = null

        if (iterator.oldText !== undefined) {
          input = {
            oldValue: iterator.oldText,
            newValue: iterator.text,
          }
          mutation = BOX_MUTATION_UPDATE
        } else {
          input = {
            text: iterator.text,
          }

          mutation = BOX_MUTATION_CREATE
        }
        promises.push(
          this.$apollo.mutate({
            mutation: mutation,
            variables: {
              input: input,
            },
          })
        )
      }
      Promise.all(promises)
        .then(() => {
          this.$apollo.queries.boxTypes.refetch()
          this.$mcToast.success(this.$t('global.alert.text.saved'))
          this.$store.commit('setting/SET_DATA', { boxType: [] })
          this.$refs.fleetBox.changeSortStatus()
          this.$refs.fleetBox.resetForm()
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
    },

    saveTermo() {
      let validate = this.$refs.fleetThermo.validateForm()
      if (validate) {
        return
      }

      let promises = []
      for (const iterator of this.$store.state.setting.data.thermoType) {
        if (!iterator) continue
        let input = {}
        let mutation = null

        if (iterator.oldText !== undefined) {
          input = {
            oldValue: iterator.oldText,
            newValue: iterator.text,
          }
          mutation = THERMO_MUTATION_UPDATE
        } else {
          input = {
            text: iterator.text,
          }

          mutation = THERMO_MUTATION_CREATE
        }
        promises.push(
          this.$apollo.mutate({
            mutation: mutation,
            variables: {
              input: input,
            },
          })
        )
      }
      Promise.all(promises)
        .then(() => {
          this.$apollo.queries.thermoTypes.refetch()
          this.$mcToast.success(this.$t('global.alert.text.saved'))
          this.$store.commit('setting/SET_DATA', { thermoType: [] })
          this.$refs.fleetThermo.changeSortStatus()
          this.$refs.fleetThermo.resetForm()
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
    },

    saveType() {
      let validate = this.$refs.fleetType.validateForm()
      if (validate) {
        return
      }

      let promises = []
      for (const iterator of this.$store.state.setting.data.fleetType) {
        if (!iterator) continue
        let manufacturer = iterator.manufacturer.model.split(' - ')

        let variables = {}
        let mutation = null
        /**
         * Cek vehicleTypeId, jika tidak null maka update jika null maka insert
         */
        if (iterator.vehicleTypeId) {
          variables = {
            input: {
              vehicleTypeId: iterator.vehicleTypeId,
              type: iterator.type,
              manufacturer: manufacturer[0],
              model: manufacturer[1],
              category: iterator.category.category || undefined,
              tonnage: parseFloat(iterator.tonnage) || undefined,
              volume: parseFloat(iterator.volume) || undefined,
              fuelType: iterator.fuelType.key || undefined,
              transmissionType: iterator.transmissionType.key || undefined,
            },
          }

          mutation = VEHICLE_TYPE_MUTATION_UPDATE
        } else {
          let arr = []
          Object.values(manufacturer).forEach((val) => {
            arr.push(val)
          })
          variables = {
            input: {
              type: iterator.type,
              manufacturer: arr[0],
              model: arr[1],
              category: iterator.category.category || '',
              tonnage: parseFloat(iterator.tonnage) || 0,
              volume: parseFloat(iterator.volume) || 0,
              fuelType: iterator.fuelType.key || '',
              transmissionType: iterator.transmissionType.key || '',
            },
          }

          mutation = VEHICLE_TYPE_MUTATION_CREATE
        }
        promises.push(
          this.$apollo.mutate({
            mutation: mutation,
            variables: variables,
          })
        )
      }

      Promise.all(promises)
        .then(() => {
          this.$mcToast.success(this.$t('global.alert.text.saved'))
          this.$store.commit('setting/SET_DATA', [])
          this.$refs.fleetType.changeSortStatus()
          this.$nextTick(() => {
            this.$apollo.queries.vehicleTypes.refetch()
          })
          this.$refs.fleetType.resetForm()
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
    },

    saveOperationalNotes() {
      let validate = this.$refs.operationalNotes.validateForm()
      if (validate) {
        return
      }
      let promises = []
      for (const iterator of this.$store.state.setting.data.operationalNotes) {
        if (!iterator) continue
        let input = {}
        let mutation = null

        if (!iterator.newId) {
          input = {
            oldNote: iterator.oldNote,
            newNote: iterator.note,
          }
          mutation = OPERATIONAL_NOTES_MUTATION_UPDATE
        } else {
          input = {
            note: iterator.note,
          }
          mutation = OPERATIONAL_NOTES_MUTATION_CREATE
        }
        promises.push(
          this.$apollo.mutate({
            mutation: mutation,
            variables: {
              input: input,
            },
          })
        )
      }
      Promise.all(promises)
        .then(() => {
          this.$mcToast.success(this.$t('setting.list.fleetSetting.successSave'))
        })
        .catch((e) => {
          // eslint-disable-next-line no-console
          console.log(e)
        })
    },
  },
}
</script>

<template>
  <Layout>
    <PageHeader
      :title="title"
      :subTitle="subTitle"
      :items="breadcrumbItems"
      hasBreadcrumb
      hasBackButton
    />

    <form>
      <b-card class="mc-card__setting">
        <b-tabs content-class="p-3 text-muted" nav-wrapper-class="mc-tab">
          <FleetCategory
            v-if="hasAccessAll(['c3a-default-setkendaraan:read', 'vehicle_categories:read'])"
            ref="fleetCat"
            status="FleetCategory"
          />
          <FleetType
            v-if="
              hasAccessAll([
                'c3a-default-setkendaraan:read',
                'vehicle_type:create',
                'vehicle_type:read',
                'vehicle_type:update',
                'vehicle_type:delete',
              ])
            "
            ref="fleetType"
            status="FleetType"
          />
          <BoxType
            v-if="
              hasAccessAll([
                'c3a-default-setkendaraan:read',
                'box_types:create',
                'box_types:read',
                'box_types:update',
                'box_types:delete',
              ])
            "
            ref="fleetBox"
            status="BoxType"
          />
          <TermoType
            v-if="
              hasAccessAll([
                'c3a-default-setkendaraan:read',
                'thermo_types:read',
                'thermo_types:create',
                'thermo_types:update',
                'thermo_types:delete',
              ])
            "
            ref="fleetThermo"
            status="TermoType"
          />
          <FuelType
            v-if="hasAccessAll(['fuel_type_price:read', 'fuel_type_price:update'])"
            ref="fleetFuel"
            status="Fuel"
          />
          <OperationalNotes
            v-if="hasAccessAll(['c3a-default-setkendaraan:read'])"
            ref="operationalNotes"
            status="OperationalNotes"
          />
        </b-tabs>
      </b-card>
    </form>
  </Layout>
</template>
